/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="common.module.ts" />

module Meevo.Components.Common {
    "use strict";

    export class ProductLotUtil {

        // Compute isExpired + the "prefix date (Expired)" display string for a lot. Shared by the
        // variantLot typeahead (dropdown results) and the Transaction Editor (pre-loaded allocations)
        // so the expiration formatting lives in one place. formatDate/translate are passed in to keep
        // this free of Angular service dependencies.
        static decorateExpiration(lot: any, formatDate: (date: any) => string, translate: (key: string) => string): void {
            if (!lot) {
                return;
            }
            if (!lot.expirationDate) {
                lot.isExpired = false;
                lot.expirationDateDisplay = null;
                return;
            }
            lot.isExpired = moment(lot.expirationDate).isBefore(moment().startOf("day"));
            lot.expirationDateDisplay = translate("LABEL_EXPIRATION_DATE_PREFIX")
                + formatDate(lot.expirationDate)
                + (lot.isExpired ? " (" + translate("LABEL_EXPIRED") + ")" : "");
        }
    }
}
